import { render, staticRenderFns } from "./IcoPlus.vue?vue&type=template&id=965be41a&lang=html"
import script from "./IcoPlus.vue?vue&type=script&lang=js"
export * from "./IcoPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports